/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon32Regular = forwardRef('KonturBonusSignIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 2a1 1 0 1 0-2 0v4H9.5A2.5 2.5 0 0 0 7 8.5v15A2.5 2.5 0 0 0 9.5 26H15v4a1 1 0 1 0 2 0v-4h2a6 6 0 0 0 0-12H9V8.5a.5.5 0 0 1 .5-.5h13a1 1 0 1 0 0-2H17V2ZM9 23.5V16h10a4 4 0 0 1 0 8H9.5a.5.5 0 0 1-.5-.5Z" })));
});
